export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'refusal-reason';

export const REQUIRED_FIELDS = ['comment'];
